import { ReactNode } from 'react';
import css from './index.module.scss';
import { intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/h5/');
export default function Charge() {
    const { useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_max_static');
    const { locale } = useRouter();

    const tabList = [
        {
            tabTitle: t('2016Wh'),
            imgPath: ['c1.webp', 'c1.png'],
        },
        {
            tabTitle: t('4032Wh'),
            imgPath: ['c2.webp', 'c2.png'],
        },
        {
            tabTitle: t('6048Wh'),
            imgPath: ['c3.webp', 'c3.png'],
        },
    ];

    const [currentIndex, setCurrentIndx] = useState(0);
    const [tabPosition, setTabPosition] = useState({
        tabWidth: '0.9rem',
        offsetLeft: locale === 'sa' ? '271' : '',
    });

    const checkTab = (indx: number, e: any) => {
        setCurrentIndx(indx);
        const dom = e.target;
        const { clientWidth, offsetLeft } = dom;
        console.log('offsetLeft', offsetLeft);
        setTabPosition({
            tabWidth: clientWidth,
            offsetLeft: offsetLeft,
        });
    };

    const capacityList = [
        [
            {
                topTitle: t('Family Use'),
                topSubT: t('29kWh/day'),
                topDesc: t('FU_desc'),
                btmTitle: intlNumber(locale, 1.6),
                btmUnion: t('Hrs'),
            },
            {
                topTitle: t('Extended Outage Use'),
                topSubT: t('3Pt6kWh/day'),
                topDesc: t('EOU_desc'),
                btmTitle: '12',
                btmUnion: t('Hrs'),
            },
            {
                topTitle: t('Temporary Outage Use'),
                topSubT: t('1Pt88kWh/day'),
                topDesc: t('TOU_desc'),
                btmTitle: '1',
                btmUnion: ['fr', 'de'].includes(locale) ? t('OneDay') : t('Day'),
            },
            {
                topTitle: t('RV Use'),
                topSubT: t('20kWh/day'),
                topDesc: '',
                btmTitle: intlNumber(locale, 2.4),
                btmUnion: t('Hrs'),
            },
        ],
        [
            {
                topTitle: t('Family Use'),
                topSubT: t('29kWh/day'),
                topDesc: t('FU_desc'),
                btmTitle: '3',
                btmUnion: t('Hrs'),
            },
            {
                topTitle: t('Extended Outage Use'),
                topSubT: t('3Pt6kWh/day'),
                topDesc: t('EOU_desc'),
                btmTitle: '1',
                btmUnion: ['fr', 'de'].includes(locale) ? t('OneDay') : t('Day'),
            },
            {
                topTitle: t('Temporary Outage Use'),
                topSubT: t('1Pt88kWh/day'),
                topDesc: t('TOU_desc'),
                btmTitle: '2',
                btmUnion: t('Day'),
            },
            {
                topTitle: t('RV Use'),
                topSubT: t('20kWh/day'),
                topDesc: '',
                btmTitle: intlNumber(locale, 4.8),
                btmUnion: t('Hrs'),
            },
        ],
        [
            {
                topTitle: t('Family Use'),
                topSubT: t('29kWh/day'),
                topDesc: t('FU_desc'),
                btmTitle: '5',
                btmUnion: t('Hrs'),
            },
            {
                topTitle: t('Extended Outage Use'),
                topSubT: t('3Pt6kWh/day'),
                topDesc: t('EOU_desc'),
                btmTitle: intlNumber(locale, 1.5),
                btmUnion: t('Day'),
            },
            {
                topTitle: t('Temporary Outage Use'),
                topSubT: t('1Pt88kWh/day'),
                topDesc: t('TOU_desc'),
                btmTitle: '3',
                btmUnion: t('Day'),
            },
            {
                topTitle: t('RV Use'),
                topSubT: t('20kWh/day'),
                topDesc: '',
                btmTitle: intlNumber(locale, 7.3),
                btmUnion: t('Hrs'),
            },
        ],
    ];

    return (
        <div className={css.charge}>
            <div className="productdesc">
                <div className="content">
                    <div className="title">{t('2016-6048Wh')}</div>
                    <div className="subtitle">{t('capacity_expand')}</div>
                    <p className="desc">
                        {t.rich('capacity_notice', {
                            line1: (child: ReactNode) => <span className="font-purple">{child}</span>,
                            line2: (child: ReactNode) => <span className="font-blue">{child}</span>,
                        })}
                    </p>
                </div>
                <div className="video-wrapper5">
                    <EFVideo className="video" sources={['/video/deltamax-h5/max-wuxian.webm', '/video/deltamax-h5/max-wuxian.mp4']} />
                </div>
                <div className="prddesc">
                    <div className="title">{t('NID')}</div>
                    <p className="subtitle">{t('NID_desc')}</p>
                    <p className="tips">{t('NID_notice')}</p>
                </div>
            </div>
            <div className="img-wrapper4">
                <EFPic name={['product4.webp', 'product4.jpg']} alt={t('NID')} />
            </div>
            <div className="img-wrapper3">
                {tabList.map((item, index) => (
                    <div key={index} className={`imgItem ${currentIndex === index ? 'show' : 'hide'}`}>
                        <EFPic name={item.imgPath} alt={t(item.tabTitle)} />
                    </div>
                ))}
            </div>
            <div className="tab">
                <ul>
                    {tabList.map((item, indx) => (
                        <li key={indx} onClick={(e) => checkTab(indx, e)} className={currentIndex === indx ? 'active' : ''}>
                            {item.tabTitle}
                        </li>
                    ))}
                </ul>
                <div
                    className="line"
                    style={{
                        left: `${tabPosition.offsetLeft}px`,
                        width: `${tabPosition.tabWidth}px`,
                    }}
                />
            </div>
            <div className="content">
                {currentIndex === 0 &&
                    capacityList[0].map((item, index) => (
                        <div className="section" key={index}>
                            <div className="top">
                                <div className="title">{item.topTitle}</div>
                                <p className="subtitle">{item.topSubT}</p>
                                <p className="desc">{item.topDesc}</p>
                            </div>
                            <div className="btm">
                                <p className="title">
                                    {item.btmTitle}&nbsp;
                                    <span className="union">{item.btmUnion}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                {currentIndex === 1 &&
                    capacityList[1].map((item, index) => (
                        <div className="section" key={index}>
                            <div className="top">
                                <div className="title">{item.topTitle}</div>
                                <p className="subtitle">{item.topSubT}</p>
                                <p className="desc">{item.topDesc}</p>
                            </div>
                            <div className="btm">
                                <p className="title">
                                    {item.btmTitle}&nbsp;
                                    <span className="union">{item.btmUnion}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                {currentIndex === 2 &&
                    capacityList[2].map((item, index) => (
                        <div className="section" key={index}>
                            <div className="top">
                                <div className="title">{item.topTitle}</div>
                                <p className="subtitle">{item.topSubT}</p>
                                <p className="desc">{item.topDesc}</p>
                            </div>
                            <div className="btm">
                                <p className="title">
                                    {item.btmTitle}&nbsp;
                                    <span className="union">{item.btmUnion}</span>
                                </p>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
}
